import { Building2, CreditCard, Users } from 'lucide-react';
import { HubPageLayout, SettingsRowDef } from './HubPageLayout';

export function CompanyHubPage() {
  const rows: SettingsRowDef[] = [
    {
      id: 'profile',
      label: 'Profile',
      desc: 'Company name, logo, address, and branding.',
      icon: Building2,
      path: '/admin/company/profile',
    },
    {
      id: 'users',
      label: 'Users',
      desc: 'Invite and manage your team members.',
      icon: Users,
      path: '/admin/company/users',
    },
    {
      id: 'plan-billing',
      label: 'Plan & Billing',
      desc: 'Users, pricing, subscription, and invoices.',
      icon: CreditCard,
      path: '/admin/company/billing',
    },
  ];

  return (
    <HubPageLayout
      title="Company"
      subtitle="Profile, users, and billing."
      rows={rows}
    />
  );
}
